module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAHCAYAAAD+guigAAAAAXNSR0IArs4c6QAAAJVJREFUSEtjZBjigCfXVpSNgWXRL4Y/cV8mH349xL3DwDiUPSCV5sv1g+3rPgYGBnMGBoaTHL+4nZ7N2vxtKPtp6EZIaCizoPjbdYwMDH6wCPjPwLDp/UvhIIbVq/8O1UgZshEinOs07f9/hkz0gGdkZJj+dvK+rCEbIUI5Tv+HquOHo7uHbA4ZjpEB8hPjaA4ZXFELAIIyI4YPfSu/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bamei/nav_on_long.png
// module id = 9dIM
// module chunks = 71